import { EmbeddingsPayload } from "@/modules/marketplaceListing/Types";
import axiosInstance from "src/utils/axios";
import { sanitizeColor } from "../utils";
import API_SERVICE from "src/utils/axios";

// CREATE JOB GROUP POST API
export async function createJobGroup (payload, signalController) {
    if(!payload?.imageURLs) return;
    const res = await axiosInstance.post("/v5/pimcore-api/createJobGroup",{
        imageURLs:payload?.imageURLs || [],
        name: payload?.name,
        selectedPreset: payload?.marketplace_id || "64cb7e5423d9644b4cf689e2",
        groupJobId: payload?.jobGroupId,
        jobType: payload?.jobType,
        selectedPlatform: payload?.selectedPlatform,
    },signalController);
    if(!res.data.success) throw new Error(res.data.message);
    return res.data.data;
}

// UPLOAD IMAGES TO TEMP BUCKET USING IMAGE ID's
export async function uploadExistingImagesToTemp (imagesId:Array<string>) {
    const res = await axiosInstance.post("v4/shootnewLifestyleImage/syncToTemp?type=imageId",imagesId);
    return res.data
}

export async function fetchGroupJobsData (groupId:string|string[], signalController?) {
    const res = await axiosInstance.get(`/v5/pimcore-api/fetchJobGroups/?groupId=${groupId}`,signalController)
    return res.data
}

export async function fetchGroupJobsDataWithUpdatedPimDetails (groupId:string|string[], queryParam?:string){
    const res = await axiosInstance.get(`/v5/pimcore-api/fetchJobGroups/?groupId=${groupId}&${queryParam}=true`)
    return res.data
}

export async function updatePimProduct (product) {
    const response = await axiosInstance.post(`/v5/pimcore-api/updateProductList`,product)
    return response?.data
}

export async function fetchPackagesList () {
    const response = await axiosInstance.get('/v5/amazonListing/packages')
    return response?.data
}

export async function addNewAngle (payload:{angleName:string, jobId:string}) {
    const resp = await axiosInstance.put('/v4/shootnewLifestyleImage/addNewAngle',{
        angle_name:payload.angleName,
        job_id: payload?.jobId
    })
    return resp?.data?.data
}

export async function getListingScore(groupId:string | string[], signalController) {
    const response = await axiosInstance.get(`/v5/amazonListing/calculateListingScore/${groupId}`, signalController);
    return response?.data;
}

export async function saveOrSubmitInstructions(payload) {
    const response = await axiosInstance.put('/v5/amazonListing/saveInstruction',payload)
    return response?.data
}

export async function getEmbeddings(payload:EmbeddingsPayload){
    const response = await axiosInstance.post('/v5/pimcore-api/getEmbeddingData',payload)
    return response?.data
}

export async function downloadCSV(payload) {
    const response = await axiosInstance.post('/v5/pimcore-api/exportCSV',payload)
    return response?.data
}

export async function addAngleAndCreateJob(payload) {
    const response = await axiosInstance.post('/v5/pimcore-api/addAngleAndCreateJob', payload)
    return response?.data
}

export async function deleteImage(payload) {
    const response = await axiosInstance.put('/v5/amazonListing/image/delete',payload)
    return response?.data
}

export async function updateBrandKitLogoOrFont(logo:File, uniqueName:string, groupName:string, type:string) {
    const formData = new FormData();
    formData.append("file", logo);
    formData.append("type", type);
    formData.append("name", uniqueName);
    formData.append("groupName", groupName);
    const res = await axiosInstance.post("/v4/brandKit", formData);
    return res.data;
}

export async function updateBrandBasedOnType(brandKitData:string, type:string, _groupName:string) {
    let _data;
    if(type === 'color'){
        _data = sanitizeColor(brandKitData)
    }else{
        _data = brandKitData
    }
    const res = await axiosInstance.post(
        "/v4/brandKit",
        {
            data: _data,
            type: type,
            name: _data,
            groupName: _groupName
        }
    );
    return res.data;
}

export async function fetchAllBrandNames () {
    const response = await axiosInstance.get('/v4/brandkit/all/groupName')
    return response?.data
}

export async function fetchBrandNameDetails (selectedBrandName:string) {
    const response = await axiosInstance.get(`/v4/brandkit?groupName=${selectedBrandName}`)
    return response?.data
}  


export async function createBrandKitName (groupName:string) {
    const response = await axiosInstance.get(`/v4/brandkit?groupName=${groupName}`)
    return response?.data
} 

export async function updatePimMasterProduct (payload) {
    const response = await axiosInstance.post('/v5/pimcore-api/updateMasterProduct',payload)
    return response?.data
}

export async function createJobOnPackageSelection (payload) {
    const response = await axiosInstance.post('/v5/pimcore-api/createJobOnPackageSelection',payload)
    return response?.data
}

export async function getMyProducts (name?:string, skipVal:number=0) {
    let queryParams = `language=en&limit=20`;
    if (name) queryParams += `&name=${name}`;
    if (skipVal) queryParams += `&skip=${skipVal}`;
    const res = await axiosInstance.get(`/v5/pimcore-api/getMasterProductList?${queryParams}`);
    return res?.data;
}
export async function addAttachmentToInstructions (payload) {
    const response = await axiosInstance.post('/v5/amazonListing/instruction/attachment',payload)
    return response?.data
}

export async function deleteBrandKitItem(id:string) {
    const res = await axiosInstance.delete(`/v4/brandKit/${id}`);
    return res.data;
}

export async function emailContent(needHelp, productId, jobOrderId) {
    const resp = await axiosInstance.post(`/v5/amazonListing/needHelpEmail`,{
        userNeedHelp:needHelp,
        productId:productId,
        jobOrderId:jobOrderId
    })
    return resp?.data
}

export async function getCustomCredits() {
    const resp = await axiosInstance.get('/v5/pimcore-api/fetchCostForCustomPackage', {
        params: {
            key: 'Custom'
        }
    });
    return resp?.data;
}
export const getSubcategoryBasedOnCategoryList = async (categoryId) => {
    try{
        let response = await axiosInstance.get(`/v5/pimcore-api/getsubCategoryBasedOnCategoryList?categoryId=${categoryId}`)
        return response?.data?.data

    }catch(error){
        console.error(error)
    }
}

export async function uploadS3ForChat(payload: FormData) {
    try {
      return await API_SERVICE({
        url: 'v1/api/chat/upload-chat-asset',
        baseURL: process.env.NEXT_PUBLIC_API_URL_V2 || "",
        method: "POST",
        data: payload,
      });
    } catch (error) {
      console.error('Error sending message:', error);
      throw error; 
    }
  }

export async function getPlatformList () {
    const response = await axiosInstance.get('/v5/pimcore-api/fetchPlatformList')
    return response?.data?.data
}
export async function updateProductSpecificAttribute (payload) {
    const response = await axiosInstance.post('/v5/pimcore-api/updateProductSpecificAttribute',payload)
    return response?.data
}
